export const FirebaseConfig = {
    apiKey: "AIzaSyBJM54euzWLlHA7goThaajBTkKx9Vun45Y",
    authDomain: "chincodrivev2.firebaseapp.com",
    databaseURL: "https://chincodrivev2.firebaseio.com",
    projectId: "chincodrivev2",
    storageBucket: "chincodrivev2.appspot.com",
    messagingSenderId: "26304787091",
    appId: "1:26304787091:web:38b827f14b5bd0abeb9366",
    measurementId: "G-V2SBK7QTVB"
};

export const google_map_key = 'AIzaSyAW0hPWtfkbE_wfwRj9TMIwI9FGLP57CLQ';